import React from 'react';
import { WatchPlaybookButton } from './WatchPlaybookButton';
export function Resources() {
  const resources = ['Peer Mentorship Circle (starts Fall 2026)', 'San Diego networking events & workshops', 'Directory of community organizations and mentors', 'Articles, videos and practical guides', 'Curated courses, tools, and related services'];
  return <section id="resources" className="py-20 md:py-24 px-6 md:px-12 bg-teal text-white" data-id="element-155">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-156">
        <div data-id="element-157">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/20 border border-accent/40 text-accent text-xs font-medium uppercase tracking-widest mb-5" data-id="element-158">
            <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse" data-id="element-159"></span>
            Coming soon
          </div>
          <h2 className="text-4xl md:text-5xl font-serif mb-6 text-clay" data-id="element-160">
            SD Career Resources
          </h2>
          <p className="text-lg text-mist/80 mb-6" data-id="element-161">
            Handpicked courses, videos, articles, local meetups, communities,
            and tools to help you get ahead!
          </p>
          <p className="text-sm text-mist/70 mb-6" data-id="element-162">
            Get started with the New Career Playbook.
          </p>
          <WatchPlaybookButton className="inline-flex items-center gap-2 px-6 py-3 bg-white text-teal font-medium rounded-md hover:bg-clay transition-colors duration-200" children="Watch the New Career Playbook" data-id="element-163" />
        </div>

        <ul className="grid grid-cols-1 gap-3" data-id="element-164">
          {resources.map((item, i) => <li key={i} className="bg-white/10 border border-white/20 rounded-lg px-4 py-3.5 text-sm text-mist flex items-center gap-3" data-id="element-165">
              <span className="w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-166"></span>
              <span data-id="element-167">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}